var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-menu',{attrs:{"default-active":"2"}},[_c('el-menu-item',{class:_vm.routerActiveClass([
        'admin_releases',
        'admin_releases_draft',
        'admin_release_edit'
      ]),on:{"click":function($event){return _vm.$router.push({ name: 'admin_releases' })}}},[_vm._v("版本发布管理")]),_c('el-menu-item',{class:_vm.routerActiveClass([
        'admin_repos',
        'admin_repos_draft',
        'admin_repo_edit'
      ]),on:{"click":function($event){return _vm.$router.push({ name: 'admin_repos' })}}},[_vm._v("资料管理")]),_c('el-menu-item',{class:_vm.routerActiveClass(['admin_nodes']),on:{"click":function($event){return _vm.$router.push({ name: 'admin_nodes' })}}},[_vm._v("节点管理")]),_c('el-menu-item',{class:_vm.routerActiveClass(['admin_users']),on:{"click":function($event){return _vm.$router.push({ name: 'admin_users' })}}},[_vm._v("用户管理")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }